<template >
  <el-dialog class="custom-class"
             top="30px"
             :center="true"
             title="修改预定信息 测试"
             :visible.sync="dialogReviseBooking"
             :showMakeResverationDialog="dialogReviseBooking"
             @close="closeReviseBookingDialog()">
    <div v-loading="loading">
      <div>
        <!-- 预定信息的链接,用于分享手机端填写 -->
        <!-- 产品信息：标题， 更换产品-->
        <div class="resv-content">
          <div>
            <el-button-group style="float: right">
              <el-button size="mini"
                         type="primary"
                         @click="selectProductBtn">更换产品</el-button>
            </el-button-group>
          </div>
          <p v-show="ota_booking_id"
             class="pid">
            平台单号：{{ ota_booking_id }}
          </p>
          <p class="title">{{ spu_title }}</p>
          <p v-show="voucher_id"
             class="pid">系统单号：{{ voucher_id }}</p>
          <div v-if="product_list_select_visable">
            <product-minin-list @selectProduct="selectProduct"></product-minin-list>
          </div>
        </div>
      </div>
      <!-- 表单内容 -->
      <div class="resv-content">
        <p v-show="sku_name"
           class="title">当前套餐：{{ sku_name }}</p>
        <span v-show="sku_item_list.length != 0"
              class="resv-title">可选套餐:</span>
        <div style="display: flex; margin: 10px 20px 20px">
          <el-radio-group v-model="selectPkgId">
            <div style="margin-bottom: 10px"
                 v-for="(item, index) in sku_item_list"
                 :key="index">
              <el-radio style="display: block"
                        size="mini"
                        :label="item.sku_id"
                        @change="selectPackage(item.sku_id)"
                        border>{{ item.sku_name }} （ID:{{ item.sku_id }}）</el-radio>
            </div>
          </el-radio-group>
        </div>

        <div v-if="sku_additions_list.length != 0"
             class="addition-area">
          <div class="addition-header">
            <span class="addition-resv-title">可选附加项:</span>
            <span @click="clearAddition"
                  class="clear-addition-button"
                  style="float: right; margin-right: 15px; color: lightgray">清除已选</span>
          </div>

          <div style="margin: 10px 20px 0px">
            <!-- 对象返显 -->
            <div v-for="item in sku_additions_list"
                 :label="item"
                 :key="item.addition_id">
              <div style="display: inline-block; height: 40px; width: auto">
                <el-checkbox style="width: 150px"
                             size="mini"
                             border
                             v-model="item.isChecked">{{ item.addition_name }}</el-checkbox>
                <div style="display: inline-block; margin-left: 20px">
                  数量：
                  <el-input-number :min="0"
                                   size="mini"
                                   controls-position="right"
                                   v-model="item.addition_num"></el-input-number>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->

        <el-divider></el-divider>
        <!-- 选择日期 -->
        <div style="display: flex; margin-bottom: 20px">
          <span class="resv-title">选择出发日期:</span>
          <el-date-picker :picker-options="pickerDate"
                          size="mini"
                          v-model="choiceDate"
                          type="date"
                          placeholder="选择日期"
                          format="yyyy 年 MM 月 dd 日"
                          value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </div>
        <!-- 场次/时间 -->
        <div style="display: flex; margin-bottom: 20px">
          <div>
            <span class="resv-title">场次/时间:</span>
            <time-input ref="TimeInput"
                        @timeChange="timeChange"
                        :select_time="selectTime"
                        :time_list="sku_times"></time-input>
          </div>
        </div>
        <!-- 套餐数量 -->
        <span class="resv-title">选择规格/数量:</span>
        <div v-for="(item, index) of price_type_list"
             :key="index"
             style="display: flex; margin: 20px 20px 20px">
          <div>
            <span>{{ item.type }}</span>
            <span>{{ item.type_info }}：</span>
          </div>
          <div>
            <el-input-number size="mini"
                             v-model="item.num"
                             controls-position="right"
                             @change="handleChangeAdult"
                             :min="0"
                             :max="20"></el-input-number>
          </div>
        </div>

        <!-- 预定人信息 -->
        <el-divider></el-divider>

        <h3 style="margin-bottom: 20px">预定人信息</h3>
        <!-- 联系人 -->
        <div style="display: flex; margin-bottom: 20px">
          <span class="resv-title">联系人:</span>
          <el-input style="width: 200px"
                    size="mini"
                    v-model="inputContact"
                    placeholder="请输入联系人姓名"></el-input>
        </div>
        <!-- 联系人电话 -->
        <div style="display: flex; margin-bottom: 20px">
          <span class="resv-title">电话:</span>
          <el-input maxlength="11"
                    show-word-limit
                    style="width: 200px"
                    size="mini"
                    v-model="inputPhone"
                    placeholder="请输入联系人电话"></el-input>
        </div>
        <!-- 联系人邮箱 -->
        <div style="display: flex; margin-bottom: 20px">
          <span class="resv-title">邮箱:</span>
          <el-input style="width: 200px"
                    size="mini"
                    v-model="inputEmail"
                    placeholder="请输入内容"></el-input>
        </div>
        <!------------------- 订单附加项信息/【新版-组件】 ------------------->
        <other-resveration-info ref="otherRresverationInfo"
                                :template="template_items"></other-resveration-info>

        <el-divider></el-divider>
        <h3 style="margin-bottom: 20px">其他信息</h3>
        <!-- 订单来源 -->
        <div style="display: flex; margin-bottom: 20px">
          <span class="resv-title">订单来源:</span>
          <el-input style="width: 200px"
                    size="mini"
                    v-model="inputSource"
                    placeholder="请输入内容"></el-input>
        </div>
        <!-- 来源编号: 设置 表单验证 -->
        <div style="display: flex; margin-bottom: 20px">
          <span class="resv-title">来源编号:</span>
          <el-input style="width: 200px"
                    size="mini"
                    v-model="inputBookingNum"
                    placeholder="请输入订单编号"></el-input>
        </div>
        <!-- 订单备注 -->
        <div style="display: flex; margin-bottom: 20px">
          <span class="resv-title">订单备注:</span>
          <el-input style="width: 200px"
                    type="textarea"
                    size="mini"
                    v-model="inputBookingRemark"
                    placeholder="请输入订单备注"></el-input>
        </div>
      </div>
      <div slot="footer"
           class="revise-dialog-footer">
        <el-button size="mini"
                   @click="makeReviseCancle">取 消</el-button>
        <el-button size="mini"
                   type="primary"
                   @click="makeReviseSubmitBtn">提交</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import TimeInput from '../../components/common/input/TimeInput'
import OtherResverationInfo from '../../components/booking/OtherResverationInfo'
import ProductMiniList from '../../components/common/select/ProductMiniList'
export default {
  name: 'makeResveration',
  components: {
    'time-input': TimeInput,
    'other-resveration-info': OtherResverationInfo,
    'product-minin-list': ProductMiniList,
  },
  data() {
    return {
      // 显示对话框
      loading: true,
      dialogReviseBooking: this.showMakeResverationDialog,
      product_list_select_visable: false,
      // 配置项
      pickerOptions: { start: '00:00', end: '23:00' },
      pickerDate: {
        // disabledDate:设置禁用状态，参数为当前日期，要求返回 Boolean
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        },
      },
      // 输入项
      sku_item_list: this.sku_list,
      spu_item_id: this.spu_id,
      spu_item_title: this.spu_title,
      voucher_id: '', // 系统单号
      choiceDate: '', //选择日期
      selectTime: '', //选择的 时间/场次
      optionsTime: '',
      selectPkgId: '', // 选择套餐的id
      // selectAdditionId: [], // 选择的附加项 id
      // select_addition_visable: false, // 预定附加项是否显示
      showAdditionVisabel: true,
      selectAdditionVisabel: false,
      sku_additions_list: [], // 附加项 可选 列表
      booking_additions: [], // 订单的返回 及 提交时的 附加项
      sku_times: [
        { value: '06:00' },
        { value: '06:30' },
        { value: '07:00' },
        { value: '07:30' },
        { value: '08:00' },
        { value: '08:30' },
        { value: '09:00' },
        { value: '09:30' },
        { value: '10:00' },
        { value: '10:30' },
        { value: '11:00' },
        { value: '12:00' },
        { value: '13:00' },
        { value: '13:30' },
        { value: '14:00' },
        { value: '14:30' },
        { value: '15:00' },
        { value: '16:00' },
        { value: '17:00' },
      ],
      inputContact: null,
      inputPhone: '',
      inputEmail: null,
      // 其他项
      template_items: [], // 附加项的信息 与返现
      inputSource: '',
      inputBookingNum: '',
      inputBookingRemark: '',
      price_type_list: this.price_type,
    }
  },
  props: {
    // 显示对话框
    showMakeResverationDialog: { type: Boolean, default: false },
    //
    ota_booking_id: String,
    // 产品ID
    spu_id: Number,
    sku_id: Number,
    // 套餐列表
    sku_list: Array, //{ sku_id: 1, sku_name: "buzhidao" }
    // 产品名称
    spu_title: String,
    sku_name: String,
    // 默认 价格规格
    price_type: {
      type: Array,
      default: function () {
        return [
          { type: '成人', type_info: '', num: 0, id: 1 },
          { type: '儿童', type_info: '', num: 0, id: 2 },
        ]
      },
    },
  },
  watch: {
    showMakeResverationDialog: {
      immediate: true,
      handler(value) {
        this.dialogReviseBooking = value
      },
    },
    spu_id: {
      immediate: true,
      handler(value) {
        this.spu_item_id = value
      },
    },
    spu_title: {
      immediate: true,
      handler(value) {
        this.spu_item_title = value
      },
    },
    sku_list: {
      immediate: true,
      handler(value) {
        this.sku_item_list = value
      },
    },
  },

  methods: {
    // 选择产品
    selectProductBtn() {
      this.product_list_select_visable = !this.product_list_select_visable
    },
    selectProduct(product_obj) {
      this.sku_item_list = product_obj.sku_list
      this.spu_item_id = product_obj.spu_id
      this.spu_item_title = product_obj.spu_title
      this.product_list_select_visable = !this.product_list_select_visable
    },
    // 选择套餐时
    selectPackage(sku_id) {
      // 点击时添加可选项
      this.sku_times = [
        { value: '08:00' },
        { value: '08:30' },
        { value: '09:00' },
        { value: '09:30' },
        { value: '10:00' },
        { value: '10:30' },
        { value: '11:00' },
        { value: '12:00' },
        { value: '13:00' },
        { value: '13:30' },
        { value: '14:00' },
        { value: '14:30' },
        { value: '15:00' },
        { value: '16:00' },
        { value: '17:00' },
      ]
      // 找到点击的套餐
      this.sku_item_list.forEach((i, index) => {
        if (i.sku_id == sku_id) {
          // --------判断套餐是否 更新 套餐 规格--------
          if (i.price_type) {
            let type_dict = new Function('return ' + i.price_type)()
            type_dict.forEach((item, index) => {
              let _obj = this.price_type_list.find((x) => {
                return x.id == item.id
              })
              if (_obj) {
                type_dict[index].num = _obj.num
              }
            })
            this.price_type_list = type_dict
          }
          // --------判断套餐是否有 附加项--------
          this.sku_additions_list = i.sku_additions
          // --------判断是否有 场次--------
          let more_info = i.more_info
          let more_info_dict = new Function('return ' + more_info)()
          if (more_info_dict) {
            if (more_info_dict.key == 'round') {
              this.sku_times = []
              for (let info_time of more_info_dict.round) {
                let value = {
                  value: info_time,
                }
                this.sku_times.push(value)
              }
            }
          }
        }
        // --------判断套餐附加的预定信息--------
        if (i.trip_res_template) {
          this.$http
            .get(`/get_reservation_stencil?id=${i.trip_res_template}`)
            .then((res) => {
              const { data, errmsg, errno } = res.data
              let information_template = new Function(
                'return ' + data[0].template
              )()
              this.template_items = information_template
            })
        } else {
          this.template_items = []
        }
      })
    },
    clearAddition() {
      // this.selectAdditionId = [];
      for (let item of this.sku_additions_list) {
        item.isChecked = false
        item.addition_num = undefined
      }
      return
    },
    // 时间改变时,给父组件赋值。
    timeChange(value) {
      this.selectTime = value

      // console.log("时间" + this.selectTime);
    },
    // 选择成人数量
    handleChangeAdult() {},
    // 选择儿童数量
    handleChangeChild() {},
    // 关闭对话况
    closeReviseBookingDialog() {
      this.product_list_select_visable = false
      this.selectPkgId = ''
      this.choiceData = ''
      this.$refs.TimeInput.time = ''
      this.price_type_list = [
        { type: '成人', type_info: '', num: 0, id: 1 },
        { type: '儿童', type_info: '', num: 0, id: 2 },
      ]
      this.inputContect = null
      // this.selectAdditionId = [];
      this.clearAddition()
      this.inputPhone = ''
      this.inputEmail = ''
      this.inputPickUp = ''
      this.inputSource = ''
      this.inputBookingNum = ''
      this.inputBookingRemark = ''
      this.template_items = []
      this.sku_additions_list = []
      this.sku_item_list = []
      // this.select_addition_visable = false;

      this.$emit('update:showMakeResverationDialog', false)
    },
    makeReviseCancle() {
      this.dialogReviseBooking = false
    },
    // 提交订单
    makeReviseSubmitBtn() {
      // 判断订单信息是填写，
      if (this.inputContact === null) {
        this.$alert('请填写联系人', '警告')
        return
      }
      if (this.inputContact === '') {
        this.$alert('请填写联系人', '警告')
        return
      }
      if (this.inputPhone === null) {
        this.$alert('请填写联系方式', '警告')
        return
      }

      if (this.inputPhone === '') {
        this.$alert('请填写联系方式', '警告')
        return
      } else if (!/^1[3456789]\d{9}$/.test(this.inputPhone)) {
        this.$alert('电话号码格式不正确', '警告')
        return
      }
      if (this.selectPkgId === '') {
        this.$alert('请选择该项目需要预定的套餐', '警告')
        return
      } else if (this.choiceDate === '') {
        this.$alert('请选择该订单需要预定的日期', '警告')
        return
      } else if (this.$refs.TimeInput.time === '') {
        this.$alert('请选择该订单需要预定的时间', '警告')
        return
      } else if (this.price_type_list) {
        let price_item = this.price_type_list
        let num_list = []
        for (let i of price_item) {
          num_list.push(i.num)
        }
        // every（）方法 ，检测数组所有元素是否都符合指定条件
        // some 方法,方法用于检测数组中的元素是否满足指定条件（函数提供）有就为真
        // 如果都等于0 或则都等于undefine。则 不合格
        // console.log(num_list);
        let is_empty = num_list.some((item) => item !== undefined)
        // console.log(is_empty);
        if (is_empty === false) {
          this.$alert('未填写预定数量', '警告')
          return
        }
        let is_empty_zero = num_list.some((item) => item !== 0)
        if (is_empty_zero === false) {
          this.$alert('未填写预定数量', '警告')
          return
        }
      }
      if (this.inputContact === null) {
        this.$alert('请填写联系人', '警告')
        return
      }
      if (this.template_items === []) {
        this.$alert('请填行程信息', '警告')
      }

      // 获取需要的数据，组成json 发送给后台。
      let bookingInfo = {}

      bookingInfo.booking_no = this.voucher_id // 系统单号
      bookingInfo.spu_id = this.spu_id
      bookingInfo.spu_name = this.spu_title
      bookingInfo.sku_id = this.selectPkgId
      bookingInfo.sku_name = this.sku_name
      bookingInfo.join_date = this.choiceDate
      bookingInfo.join_time = this.$refs.TimeInput.time
      bookingInfo.num_list = this.price_type_list
      bookingInfo.select_addition_dict = this.sku_additions_list
      bookingInfo.contact_name = this.inputContact
      bookingInfo.contact_phone = this.inputPhone
      bookingInfo.contact_email = this.inputEmail
      bookingInfo.source_from = this.inputSource
      bookingInfo.source_booking_id = this.inputBookingNum
      bookingInfo.remark = this.inputBookingRemark

      this.template_items.forEach((item) => {
        if (item.type == 'textarea' && item.value != undefined) {
          item.value = item.value.replace(/[\r\n]/g, '')
        }
      })
      bookingInfo.template_info = this.template_items
      // 提交数据 终止 测试
      console.log(bookingInfo)

      // 提交的订单信息
      this.$http.post('/booking/new-order', bookingInfo).then((res) => {
        const { errmsg, errno } = res.data
        if (errno == '0') {
          this.$notify({
            title: '成功',
            message: errmsg,
            type: 'success',
          })
          this.dialogReviseBooking = false
          this.selectPkgId = ''
          this.choiceData = ''
          this.$refs.TimeInput.time = ''
          this.price_type_list = [
            { type: '成人', type_info: '', num: 0, id: 1 },
            { type: '儿童', type_info: '', num: 0, id: 2 },
          ]
          this.inputContact = null
          // this.selectAdditionId = [];
          this.clearAddition()
          this.inputPhone = ''
          this.inputEmail = ''
          this.inputPickUp = ''
          this.inputSource = ''
          this.inputBookingNum = ''
          this.inputBookingRemark = ''
          this.template_items = []
        } else if (errno == '4004') {
          this.$notify({
            title: '警告',
            message: errmsg,
            type: 'warning',
          })
        } else if (errno == '4003') {
          // 是否修改联系人姓名
          this.$notify({
            title: '警告',
            message: errmsg,
            type: 'warning',
          })
        }
      })
    },
    //
    getBookingNumber() {
      let randomNum
      let date = new Date()

      var Year = 0
      var Month = 0
      var Day = 0
      var Hour = 0
      var Minutes = 0
      var Second = 0
      var CurrentDate = ''
      //初始化时间
      Year = date.getFullYear() //ie火狐下都可以
      Month = date.getMonth() + 1
      Day = date.getDate()
      Hour = date.getHours()
      Minutes = date.getMinutes()
      Second = date.getSeconds()
      CurrentDate += Year
      // 月份
      if (Month >= 10) {
        CurrentDate += Month
      } else {
        CurrentDate += '0' + Month
      }
      // 日期
      if (Day >= 10) {
        CurrentDate += Day
      } else {
        CurrentDate += '0' + Day
      }
      // 小时
      if (Hour >= 10) {
        CurrentDate += Hour
      } else {
        CurrentDate += '0' + Hour
      }
      // 分钟
      if (Minutes >= 10) {
        CurrentDate += Minutes
      } else {
        CurrentDate += '0' + Minutes
      }
      // 秒
      if (Second >= 10) {
        CurrentDate += Second
      } else {
        CurrentDate += '0' + Second
      }
      // 生成随机数
      do randomNum = Math.floor(Math.random() * 10000)
      while (randomNum < 1000)

      this.inputBookingNum = randomNum + CurrentDate
      console.log(this.inputBookingNum)
    },
    //
  },
}
</script>

<style>
.title {
  font-size: medium;
}
.pid {
  font-size: smaller;
  color: darkgray;
}
.resv-content {
  width: auto;
  height: auto;
  background-color: aliceblue;
  border: 1px solid dashed darkgray;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 20px;
}
.resv-title {
  padding: 5px 0 5px;
  margin-right: 10px;
}
.addition-resv-title {
  padding: 5px 0 5px;
  margin-right: 10px;
  margin-left: 20px;
}
.show-addition-has-select {
  width: 40%;
  padding: 10px;
  margin-left: 20px;
  background-color: whitesmoke;
  border: 1px solid wheat;
}

.addition-area {
  margin: 0 20px;
  padding: 10px 0;
  border: 1px dashed lightgray;
  background-color: ivory;
  border-radius: 3px;
}

.clear-addition-button {
  display: none;
  cursor: pointer;
}
.addition-header:hover .clear-addition-button {
  display: block;
}
.revise-dialog-footer {
  text-align: center;
}
</style>